import { createFileRoute, notFound } from '@tanstack/react-router'
import { getStaticPage } from '@/src/lib/static-pages'
import { Markdown } from '@/src/components/Markdown'
import { NotFound } from '@/src/components/NotFound'
import { useTranslation } from '@/src/i18n/client'

export const Route = createFileRoute('/_static/terms')({
  loader: () => {
    const enPage = getStaticPage('terms', 'en')
    const dePage = getStaticPage('terms', 'de')
    
    if (!enPage && !dePage) {
      throw notFound()
    }
    
    return { enPage, dePage }
  },
  head: ({ loaderData }) => ({
    meta: [
      { title: loaderData?.enPage?.title || 'Terms of Service - GearLens' },
      { name: 'description', content: loaderData?.enPage?.description || 'Terms and conditions for using the GearLens service' }
    ],
  }),
  component: TermsPage,
})

function TermsPage() {
  const { i18n } = useTranslation()
  const { enPage, dePage } = Route.useLoaderData()
  
  const currentLocale = i18n.language.split('-')[0]
  const page = currentLocale === 'de' ? dePage : enPage
  
  if (!page) {
    return <NotFound />
  }

  return (
    <div className="container mx-auto max-w-4xl px-4 py-12">
      <Markdown 
        content={page.content} 
        className="prose prose-gray dark:prose-invert max-w-none"
      />
    </div>
  )
}
